import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "components/fields/InputField";
import { loginAction } from "../../redux/action/index";
import { getCookie, setCookie } from "utils/cookie";
import Turnstile from "react-turnstile";
import { API_URL } from "utils/config";
import axios from "axios";
import toast from "react-hot-toast";
import Logo from "../../assets/img/client_logo.png";
import { sanitizeInputManually } from "../../utils/sanitizeHtml";
import { FaEye, FaEyeSlash } from "react-icons/fa";
// import Logo from "../../assets/img/logo1.jpeg";
// import Logo from "../../assets/img/logo1.jpeg";

export default function SignIn() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [captcha, setCaptcha] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // For storing validation errors
  const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility
  const login = getCookie("token") ? true : false;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (login && getCookie("role") === "super-admin") {
      navigate("/admin/dashboard");
    } else if (
      login &&
      (getCookie("role") === "user" || getCookie("role") === "admin")
    ) {
      navigate("/user/raise-complaint");
    }
  }, [login, navigate]);

  const validateForm = () => {
    const newErrors = {};

    if (!userName.trim()) {
      newErrors.userName = "Username is required.";
    }

    if (!password) {
      newErrors.password = "Password is required.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleCaptchaChange = async (value) => {
    try {
      const body = {
        captcha: true,
        g_recaptcha_response: value,
      };
      const response = await axios.post(API_URL + "/auth/verify_captcha", body);
      if (response?.data?.status === 200) {
        setCaptcha(true);
        setCaptchaVerified(true);
        console.log("captcha is verified");
      } else {
        toast.error(response?.data?.detail[0]?.msg);
        console.log("captcha is not verified");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleLogin = async () => {
    if (validateForm() && !loading && captchaVerified) {
      setLoading(true); // Disable the button
      try {
        const response = await dispatch(
          loginAction({
            email: userName,
            password: password,
          })
        );
        if (response !== undefined) {
          if (getCookie("role") === "user") {
            setCookie("role", "user");
            navigate("/user/raise-complaint");
          } else {
            navigate("/admin/dashboard");
          }
        }
      } catch (error) {
        console.log("Login err:", error);
      } finally {
        setLoading(false); // Re-enable the button
      }
    }
  };

  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <img src={Logo} alt="logo" width={150} />
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Sign In
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your username and password to sign in!
        </p>
        <InputField
          variant="auth"
          extra="mb-3"
          label="Email*"
          placeholder="Email address"
          id="username"
          value={userName}
          onChange={(e) => setUserName(sanitizeInputManually(e.target.value))}
          type="text"
          error={errors.userName}
        />
        {errors.userName && (
          <p className="mb-3 text-sm text-red-500">{errors.userName}</p>
        )}
        <div className="relative">
          <InputField
            variant="auth"
            extra="mb-3"
            label="Password*"
            placeholder="************"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={showPassword ? "text" : "password"}
            error={errors.password}
          />

          <span
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-[43px] cursor-pointer"
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>
        {errors.password && (
          <p className="mb-3 text-sm text-red-500">{errors.password}</p>
        )}
        <Turnstile
          sitekey="0x4AAAAAAAkH86FYslmjxCH3"
          // testkey
          // sitekey="1x00000000000000000000AA"
          className="mt-2"
          onVerify={(token) => {
            handleCaptchaChange(token);
            // setCaptcha(true);
            // setCaptchaVerified(true);
          }}
        />
        <div className="mb-4 flex items-center justify-between px-2">
          <a
            className="text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
            href="/auth/forgot-password"
          >
            Forgot Password?
          </a>
        </div>
        <button
          onClick={handleLogin}
          disabled={loading || !captchaVerified || !captcha}
          className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 disabled:cursor-not-allowed disabled:bg-gray-600 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
        >
          {loading ? "Signing In..." : "Sign In"}
        </button>
        <div className="mt-4">
          <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
            Not registered yet?
          </span>
          <a
            href="/auth/register"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Create an account
          </a>
        </div>
      </div>
    </div>
  );
}
